import { render, staticRenderFns } from "./leasons.vue?vue&type=template&id=9550326a&scoped=true"
import script from "./leasons.vue?vue&type=script&lang=js"
export * from "./leasons.vue?vue&type=script&lang=js"
import style0 from "./leasons.vue?vue&type=style&index=0&id=9550326a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9550326a",
  null
  
)

export default component.exports